<template>
    <div>
        <div class="m-portlet left">
            <div class="m-portlet__body">
                <el-form>
                    <el-form-item>
                        <el-button style="width: 100%" @click="handleCreateGoods()">
                            创建商品
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>

        </div>
        <div class="m-portlet right" :style="{'height':(clientHeight-250)+'px'}">
            <div class="m-portlet__body">
                <table class="table" v-loading="loading">
                    <thead>
                    <tr>
                        <th>商品名</th>
                        <th>创建时间</th>
                        <th>价格</th>
                        <th>数量</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in shopList" :key="index">
                        <td>{{item.name}}</td>
                        <td>{{item.created_date}}</td>
                        <td>{{item.price}}</td>
                        <td>{{item.amount}}</td>
                        <td>
                            <el-button size="mini" @click="handleUpdateGood(item.id)">修改</el-button>
                            <el-button size="mini" @click="handleDeleteGood(item.id)">刪除</el-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="text-center m-t-10">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                path: '/shop',
                loading: true,
                button_loading: false,
                shopList: {},
                currentPage: 1,
                currentPageSize: 10,
                total: 1,
                store_goods:{
                    button_loading: false,
                },
                update_goods:{
                    button_loading: false,
                    good:{
                        id:'',
                        name:'',
                        price:'',
                        amount:'',
                    }
                }
            }
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        created() {
            this.handleCreate();
            this.handleShopList();
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        break;
                    case 'list':
                        if (Object.keys(data.shopList).length !== 0) {
                            this.shopList=data.shopList
                        } else {
                            this.shopList = new Object();
                        }
                        this.loading=false
                        break;
                    case 'store_goods':
                        this.$set(this.shopList,data.good.id,data.good)
                        this.store_goods.button_loading=false;
                        break;
                    case 'show_goods':
                        this.update_goods.good=data.good
                        break;
                    case 'update_goods':
                        this.$set(this.shopList,data.good.id,data.good)
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.$Win.closeModal();
                        break;
                    case 'delete_goods':
                        this.$message({
                            message: '刪除成功',
                            type: 'success'
                        });
                        this.$delete(this.shopList,data.good_id)
                        break;
                }
            },
            handleShopList(currentPage = 1, currentPageSize = 10) {
                this.$wApi.send(this.path, 'list', {
                    'currentPage': currentPage,
                    'currentPageSize': currentPageSize,
                });
            },
            handleCreateGoods() {
                this.$Win.openModal('Dialog_CreateGoods', 300, 400, '创建商品');
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleShopList(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleShopList(this.currentPage, this.currentPageSize)
            },
            handleUpdateGood(id){
                this.$Win.openModal('Dialog_UpdateGoods', 300, 400, '修改商品',{'good_id':id});
            },
            handleDeleteGood(good_id){
                this.$wApi.send(this.path, 'delete_goods', {
                    'shop_id': good_id,
                });
            }
        }
    }
</script>

<style scoped>

</style>